import type { RouteObject } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

import { AuthStrategy } from '@/lib/auth/strategy'
import { StrategyGuard } from '@/components/auth/strategy-guard'

export const route: RouteObject = {
	path: 'custom',
	element: (
		<StrategyGuard expected={AuthStrategy.CUSTOM}>
			<Outlet />
		</StrategyGuard>
	),
	children: [
		{
			path: 'reset-password',
			handle: { pageName: 'Reset Password' },
			lazy: async () => {
				const { Page } = await import('@/pages/auth/custom/reset-password')
				return { Component: Page }
			},
		},
		{
			path: 'sign-in',
			handle: { pageName: 'Sign In' },
			lazy: async () => {
				const { Page } = await import('@/pages/auth/custom/sign-in')
				return { Component: Page }
			},
		},
		{
			path: 'sign-up',
			handle: { pageName: 'Sign Up' },
			lazy: async () => {
				const { Page } = await import('@/pages/auth/custom/sign-up')
				return { Component: Page }
			},
		},
	],
}
